<template>
  <div class="chat-group-manage">
    <div
        class="chat-group-manage__layout"
        :class="{'chat-group-manage__layout--with-panel': currentGroup}"
    >
      <div class="chat-group-manage__main">
        <div class="chat-group-manage__toolbar">
          <el-button type="primary" icon="el-icon-refresh" @click="fetchMerchantList">刷新</el-button>
        </div>

        <div class="chat-group-manage__table-wrap">
          <el-table
              ref="merchantTable"
              v-loading="merchantLoading"
              :data="merchantList"
              stripe
              row-key="id"
              empty-text="暂无已创建群聊的合伙人"
              @expand-change="handleExpandChange"
          >
            <el-table-column type="expand">
              <template slot-scope="{ row: merchantRow }">
                <div class="chat-group-manage__expand">
                  <el-table
                      v-loading="merchantRow.groupLoading"
                      :data="merchantRow.groups || []"
                      size="small"
                      stripe
                      empty-text="该合伙人暂无群聊"
                      :row-class-name="groupTableRowClassName"
                  >
                    <el-table-column label="ID" prop="id" width="80"></el-table-column>
                    <el-table-column label="头像" width="72" align="center">
                      <template slot-scope="scope">
                        <el-image
                            v-if="scope.row.avatar"
                            class="chat-group-manage__avatar"
                            :src="buildFileUrl(scope.row.avatar)"
                            :preview-src-list="[buildFileUrl(scope.row.avatar)]"
                            fit="cover"
                        ></el-image>
                        <div v-else class="chat-group-manage__avatar chat-group-manage__avatar--empty">
                          <i class="el-icon-user-solid"></i>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="群名称" prop="groupName" min-width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column label="成员数量" width="90" align="center">
                      <template slot-scope="scope">{{ scope.row.memberCount || 0 }}</template>
                    </el-table-column>
                    <el-table-column label="群状态" width="100" align="center">
                      <template slot-scope="scope">
                        <el-tag
                            size="mini"
                            :type="scope.row.status === 1 ? 'success' : 'info'"
                            :class="{'chat-group-manage__status-tag--clickable': scope.row.status === 0}"
                            @click.native="scope.row.status === 0 && openForbidReasonDialog(scope.row)"
                        >
                          {{ formatGroupStatus(scope.row.status) }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="群公告" prop="notice" min-width="160" show-overflow-tooltip>
                      <template slot-scope="scope">{{ scope.row.notice || '—' }}</template>
                    </el-table-column>
                    <el-table-column label="创建时间" min-width="160" show-overflow-tooltip>
                      <template slot-scope="scope">{{ formatDateTime(scope.row.createdTime) }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" min-width="160" show-overflow-tooltip>
                      <template slot-scope="scope">{{ formatDateTime(scope.row.updatedTime) }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="120" fixed="right" align="center">
                      <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain @click="openChatWindow(scope.row)">聊天记录</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="ID" prop="id" width="80"></el-table-column>
            <el-table-column label="店铺名" prop="store" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column label="昵称" prop="nickname" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.nickname || '—' }}</template>
            </el-table-column>
            <el-table-column label="店铺电话" prop="phone" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="地区" prop="areaName" min-width="160" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.areaName || '—' }}</template>
            </el-table-column>
            <el-table-column label="状态" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.state === '0'" class="chat-group-manage__state chat-group-manage__state--pending">审核中</span>
                <span v-else-if="scope.row.state === '1'" class="chat-group-manage__state chat-group-manage__state--reject">审核失败</span>
                <span v-else-if="scope.row.state === '2'" class="chat-group-manage__state chat-group-manage__state--pass">已通过</span>
                <span v-else>—</span>
              </template>
            </el-table-column>
            <el-table-column label="群聊数量" prop="groupCount" width="90" align="center">
              <template slot-scope="scope">{{ scope.row.groupCount != null ? scope.row.groupCount : 0 }}</template>
            </el-table-column>
            <el-table-column label="群聊配额" prop="chatGroupSize" width="90" align="center">
              <template slot-scope="scope">{{ scope.row.chatGroupSize != null ? scope.row.chatGroupSize : 0 }}</template>
            </el-table-column>
          </el-table>
        </div>

        <div class="chat-group-manage__pagination">
          <el-pagination
              background
              :current-page="pageNum"
              :page-size="pageSize"
              :page-sizes="[10, 20, 50, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          />
        </div>
      </div>

      <chat-group-history-panel
          v-if="currentGroup"
          class="chat-group-manage__history-panel"
          :group="currentGroup"
          @close="closeChatWindow"
      ></chat-group-history-panel>
    </div>

    <el-dialog
        title="封禁原因"
        :visible.sync="forbidReasonDialogVisible"
        width="480px"
        append-to-body
    >
      <div class="chat-group-manage__forbid-reason-group">群名称：{{ forbidReasonGroupName || '—' }}</div>
      <div class="chat-group-manage__forbid-reason-text">{{ forbidReasonText || '暂无封禁原因' }}</div>
      <div slot="footer">
        <el-button type="primary" @click="forbidReasonDialogVisible = false">知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageAgencyMerchants from '@/api/chat/chatGroup/pageAgencyMerchants'
import listChatGroupByMerchant from '@/api/chat/chatGroup/listByMerchant'
import ChatGroupHistoryPanel from './components/ChatGroupHistoryPanel.vue'

export default {
  name: 'ChatGroupManage',
  components: { ChatGroupHistoryPanel },
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      merchantLoading: false,
      merchantList: [],
      expandedMerchantIds: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      currentGroup: null,
      forbidReasonDialogVisible: false,
      forbidReasonGroupName: '',
      forbidReasonText: '',
    }
  },
  mounted() {
    this.fetchMerchantList()
  },
  methods: {
    fetchMerchantList() {
      this.merchantLoading = true
      const expandedIds = [...this.expandedMerchantIds]
      pageAgencyMerchants(this.pageNum, this.pageSize).then(res => {
        if (res.code === 1) {
          const list = res.data.data || []
          this.merchantList = list.map(item => ({
            ...item,
            groups: [],
            groupsLoaded: false,
            groupLoading: false,
          }))
          this.total = res.data.total || 0
          return this.refreshExpandedMerchantGroups(expandedIds)
        }
      }).finally(() => {
        this.merchantLoading = false
      })
    },
    refreshExpandedMerchantGroups(expandedIds) {
      if (!expandedIds.length) {
        return Promise.resolve()
      }
      const rows = this.merchantList.filter(row => expandedIds.includes(row.id))
      if (!rows.length) {
        this.expandedMerchantIds = []
        return Promise.resolve()
      }
      return Promise.all(rows.map(row => this.loadMerchantGroups(row, true))).then(() => {
        this.syncCurrentGroupFromList()
        this.$nextTick(() => {
          const table = this.$refs.merchantTable
          if (!table) {
            return
          }
          rows.forEach(row => {
            table.toggleRowExpansion(row, true)
          })
        })
      })
    },
    syncCurrentGroupFromList() {
      if (!this.currentGroup) {
        return
      }
      for (const merchant of this.merchantList) {
        const groups = merchant.groups || []
        const found = groups.find(group => group.id === this.currentGroup.id)
        if (found) {
          this.currentGroup = { ...found }
          return
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.fetchMerchantList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.fetchMerchantList()
    },
    handleExpandChange(row, expandedRows) {
      this.expandedMerchantIds = expandedRows.map(item => item.id)
      const expanded = expandedRows.some(item => item.id === row.id)
      if (!expanded || row.groupsLoaded) {
        return
      }
      this.loadMerchantGroups(row)
    },
    loadMerchantGroups(row, force = false) {
      if (!row || !row.id) {
        return Promise.resolve()
      }
      if (!force && row.groupsLoaded) {
        return Promise.resolve()
      }
      this.$set(row, 'groupLoading', true)
      return listChatGroupByMerchant(row.id).then(res => {
        if (res.code === 1) {
          this.$set(row, 'groups', res.data || [])
          this.$set(row, 'groupsLoaded', true)
        }
      }).finally(() => {
        this.$set(row, 'groupLoading', false)
      })
    },
    openChatWindow(group) {
      this.currentGroup = { ...group }
    },
    closeChatWindow() {
      this.currentGroup = null
    },
    groupTableRowClassName({ row }) {
      if (this.currentGroup && row.id === this.currentGroup.id) {
        return 'chat-group-manage__row--active'
      }
      return ''
    },
    openForbidReasonDialog(group) {
      if (!group || group.status !== 0) {
        return
      }
      this.forbidReasonGroupName = group.groupName || String(group.id)
      this.forbidReasonText = group.forbidReason || ''
      this.forbidReasonDialogVisible = true
    },
    buildFileUrl(path) {
      if (!path) {
        return ''
      }
      return this.fileBaseUrl + (path.startsWith('/') ? path : '/' + path)
    },
    formatGroupStatus(status) {
      return status === 1 ? '正常' : '已封禁'
    },
    formatDateTime(value) {
      if (!value) {
        return '—'
      }
      if (Array.isArray(value)) {
        const [year, month, day, hour = 0, minute = 0, second = 0] = value
        const pad = n => String(n).padStart(2, '0')
        return `${year}-${pad(month)}-${pad(day)} ${pad(hour)}:${pad(minute)}:${pad(second)}`
      }
      const str = String(value).trim()
      if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}/.test(str)) {
        return str.replace('T', ' ').replace(/\.\d+/, '').slice(0, 19)
      }
      return str.replace('T', ' ')
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-group-manage {
  height: calc(100vh - 70px);
  padding: 16px;
  box-sizing: border-box;

  &__layout {
    display: flex;
    gap: 0;
    height: 100%;
    align-items: stretch;

    &--with-panel {
      gap: 12px;

      .chat-group-manage__main,
      .chat-group-manage__history-panel {
        flex: 1 1 50%;
        min-width: 0;
      }
    }
  }

  &__main {
    flex: 1;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    box-sizing: border-box;
    overflow: hidden;
  }

  &__history-panel {
    flex: 1 1 50%;
    min-width: 0;
    height: 100%;
  }

  &__toolbar {
    margin-bottom: 16px;
    flex-shrink: 0;
  }

  &__expand {
    padding: 8px 16px 8px 48px;
    background: #fafbfc;
  }

  &__table-wrap {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }

  &__pagination {
    margin-top: 16px;
    text-align: right;
    flex-shrink: 0;
  }

  &__avatar {
    width: 40px;
    height: 40px;
    border-radius: 6px;

    &--empty {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f7fa;
      color: #c0c4cc;
      font-size: 18px;
    }
  }

  &__status-tag--clickable {
    cursor: pointer;
  }

  &__state {
    font-size: 12px;

    &--pending {
      color: #e6a23c;
    }

    &--reject {
      color: #f56c6c;
    }

    &--pass {
      color: #67c23a;
    }
  }

  &__forbid-reason-group {
    margin-bottom: 12px;
    font-size: 14px;
    color: #606266;
  }

  &__forbid-reason-text {
    padding: 12px;
    background: #f5f7fa;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.6;
    color: #303133;
    white-space: pre-wrap;
    word-break: break-all;
    min-height: 48px;
  }
}

::v-deep .chat-group-manage__row--active > td {
  background: #ecf5ff !important;
}
</style>
